export enum UiLanguages {
  EN = 'en',
  FR = 'fr',
}

export const regionalLangFormats = {
  [UiLanguages.EN]: 'en-US',
  [UiLanguages.FR]: 'fr-FR',
};
